import React from 'react';
import { motion } from 'framer-motion';
export function OpeningHook() {
  return <section className="w-full bg-midnight-deep py-24 px-6 border-y border-cyan-signal/10" data-id="element-144">
      <div className="max-w-3xl mx-auto flex flex-col items-center text-center" data-id="element-145">
        <motion.div className="font-mono text-6xl md:text-8xl text-cyan-signal font-bold tracking-tighter mb-12 drop-shadow-[0_0_15px_rgba(61,169,252,0.3)]" initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} data-id="element-146">
          3
          <motion.span animate={{
          opacity: [1, 0, 1]
        }} transition={{
          repeat: Infinity,
          duration: 1,
          ease: 'linear'
        }} data-id="element-147">
            :
          </motion.span>
          14 AM
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="space-y-6 text-lg md:text-xl text-steel leading-relaxed font-body italic" data-id="element-148">
          <p data-id="element-149">
            Son las 3:14 AM. Estás mirando el techo, calculando cuántas horas de
            sueño te quedan si te durmieras justo ahora. Sientes el corazón
            acelerado, una lista interminable de pendientes dando vueltas en tu
            cabeza y esa presión en el pecho de saber que mañana será otro día
            de neblina mental y agotamiento.
          </p>
          <p data-id="element-150">
            No es que no estés cansado. Tu cuerpo está al límite, pero tu
            cerebro se niega a soltar el mando. Tu interruptor biológico está
            atascado en la posición de "alerta máxima" y ninguna técnica de
            meditación suave para principiantes va a cambiar eso.
          </p>
        </motion.div>
      </div>
    </section>;
}